import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Palavra Chave',
        path: '/biblioteca/bibpalavrachave',
        name: 'bibpalavrachave',
        component: () => import('@/views/biblioteca/bibpalavrachave/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CADASTROPALAVRACHAVENOVO_MENU_1300200199],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Palavra Chave',
        path: '/biblioteca/bibpalavrachave/cadastro/:id?',
        parent: 'bibpalavrachave',
        name: 'bibpalavrachave_create',
        component: () => import('@/views/biblioteca/bibpalavrachave/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_CADASTROPALAVRACHAVENOVO_MENU_1300200199],
        },
        goesToMenu: true,
    },
]
